export default __webpack_public_path__ + "b368b971005b471a9578c2f29472bb66.png";